module.exports = __webpack_public_path__ + "98df09377f6f9e531abaa1daed1cff26.png";